import { createUserInteraction } from './createUserInteraction';
import { fetchUserInteractions } from './fetchUserInteractions';

export const userInteractionService = {
  createUserInteraction,
  fetchUserInteractions,
};
